import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { Block, BlockHeading, HeadingIcon, Text, Base } from '@gandi/ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const displayBlock = {
  display: 'block'
};
function extractBankValues(bu) {
  return {
    buName: bu.address.name || bu.name,
    bankName: bu.bank.name,
    bankStreet: bu.bank.address.street,
    bankZipAndCity: bu.bank.address.zip ? `${bu.bank.address.zip} ${bu.bank.address.city}` : bu.bank.address.city,
    bankCountry: bu.bank.address.country_name,
    bankAccount: bu.bank.account || '-',
    bankIBAN: bu.bank.iban || '-',
    bankBIC: bu.bank.bic || '-',
    bankEmail: bu.email,
    bankFax: bu.fax
  };
}
function getTransferInfos(bu, translator) {
  if (!bu.bank) {
    return [];
  }
  const bankValues = extractBankValues(bu);
  return [{
    label: translator.__('Bank Address'),
    values: [bankValues.bankName, bankValues.bankStreet, bankValues.bankZipAndCity, bankValues.bankCountry]
  }, {
    label: translator.__('Account holder'),
    values: [bankValues.buName, bankValues.bankAccount]
  }, {
    label: translator.__('IBAN'),
    values: [bankValues.bankIBAN]
  }, {
    label: translator.__('BIC'),
    values: [bankValues.bankBIC]
  }];
}
function getCheckInfos(bu) {
  return [{
    values: [bu.address.name || bu.name, bu.address.street, bu.address.street2 || '', `${bu.address.zip || ''} ${bu.address.city || ''}`, bu.address.country_name]
  }];
}
function getMandateInfos(bu, translator) {
  return [{
    label: translator.__('Email'),
    values: [bu.email]
  }, {
    label: translator.__('Mail'),
    values: [bu.address.name || bu.name, bu.address.street, bu.address.street2 || '', `${bu.address.zip || ''} ${bu.address.city || ''}`, bu.address.country_name]
  }, {
    label: translator.__('Fax'),
    values: [bu.fax]
  }];
}
function getPaymentTypeTranslation(
// eslint-disable-next-line camelcase
{
  payment_type,
  bu
}, translator) {
  // eslint-disable-next-line camelcase
  switch (payment_type) {
    case 'transfer':
      return {
        title: translator.__('Where to address your bank transfer.'),
        content: getTransferInfos(bu, translator)
      };
    case 'check':
      return {
        title: translator.__('Where to send your check purchase.'),
        content: getCheckInfos(bu)
      };
    case 'mandate':
      return {
        title: translator.__('Where to send your purchase order.'),
        content: getMandateInfos(bu, translator)
      };
    default:
      return undefined;
  }
}
const InfoItem = (value, idx) => /*#__PURE__*/_jsx("span", {
  style: displayBlock,
  children: value
}, `destination-info-item-${idx}`);
const InfoRow = (info, idx) => /*#__PURE__*/_jsxs(Base, {
  flex: true,
  flexJustifyBetween: true,
  flexWrap: true,
  gap: "xsmall",
  marginBottom: "small",
  children: [/*#__PURE__*/_jsx(Text, {
    children: info.label
  }), /*#__PURE__*/_jsx(Base, {
    tagName: "p",
    weight: "semibold",
    align: "end",
    margin: "none",
    children: info.values.filter(Boolean).map(InfoItem)
  })]
}, idx);
export default function OfflinePayment({
  order
}) {
  const translator = useTranslator();
  const paymentTypeTranslation = getPaymentTypeTranslation(order, translator);
  if (!paymentTypeTranslation) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Block, {
    children: [/*#__PURE__*/_jsxs(BlockHeading, {
      fontSize: "m",
      children: [/*#__PURE__*/_jsx(HeadingIcon, {
        name: "arrowRight"
      }), paymentTypeTranslation.title]
    }), paymentTypeTranslation.content.map(InfoRow)]
  });
}